import React from 'react'
import { Route, useLocation } from 'react-router-dom'
import Aboutme from './Aboutme'
import Cta from './Cta'
import ProjectPage from '../Pages/ProjectPage'
import Projects from './Projects'
import TechstackSection from './TechstackSection'
import { Routes } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'

export default function AnimatedRoutes() {

  const location = useLocation();



  return (
    <AnimatePresence>
    <Routes location={location} key={location.pathname}>
    <Route
    path="/"
    element={
      <div className="bg-[#191919]  h-100 md:px-16 md:py-6 px-6 py-10 text-white flex flex-col gap-32 items-center">
        <Cta />
        {/* <ProjectPage open={true}/> */}

        <TechstackSection />
        <Projects />
        <Aboutme />

      </div>
    }
  />

  
  <Route path="/todoly" element={<ProjectPage />} />
 
  {/* Add more routes here */}
</Routes>
s
</AnimatePresence>
  )
}
